let userPremiumStatus = false;

export function setUserPremiumStatus(calculatedPremiumStatus: boolean): void {
    userPremiumStatus = calculatedPremiumStatus;
}

export function getUserPremiumStatus(): boolean {
    return userPremiumStatus;
}
